import { fetchUserData } from '~/hooks/queries/use-user-data-query.js';

export async function getUserFromSession() {
  const { data } = await fetchUserData();

  if (data?.viewer?.id) {
    return data.viewer;
  }

  return null;
}
